// Scene automation uses the same Mongo Studio catalog as manual scene selection.
// It never defines prices or tier names; entitlements come from the master Live catalog.
export const DEFAULT_VIDEO_SCENES=[
 {id:"intro",name:"Intro Video",kind:"intro",layout:"spotlight",asset_id:null,auto_play:false,auto_next:true,next_scene_id:"live",pre_intro_enabled:false,pre_intro_seconds:30,duration_seconds:30,loop:false,positions:{}},
 {id:"outro",name:"Outro Video",kind:"outro",layout:"spotlight",asset_id:null,auto_play:false,auto_next:false,next_scene_id:null,pre_intro_enabled:false,pre_intro_seconds:30,duration_seconds:30,loop:false,positions:{}}
];
// Adjust only the previously shipped default ordering. Custom drag order is authoritative.
const LEGACY_DEFAULT_IDS=["countdown","live","demo","break","intro","outro"];
export function normalizeInitialSceneOrder(scenes=[]){
 if(!Array.isArray(scenes))return [];
 const ids=scenes.map(scene=>scene.id);
 const known=ids.filter(id=>LEGACY_DEFAULT_IDS.includes(id));
 const legacy=known.length===LEGACY_DEFAULT_IDS.length&&known.every((id,index)=>id===LEGACY_DEFAULT_IDS[index]);
 if(!legacy)return scenes;
 const intro=scenes.find(s=>s.id==="intro");
 return [intro,...scenes.filter(s=>s.id!=="intro"&&s.id!=="outro"),...scenes.filter(s=>s.id==="outro")];
}
export const isRetiredMeetingScene=scene=>scene?.kind==="live"&&String(scene.name||"").trim()==="Meeting";
export function prepareStudioScenes(scenes=[],legacy={}){
 const cleaned=(Array.isArray(scenes)?scenes:[]).filter(scene=>scene&&typeof scene==="object"&&!isRetiredMeetingScene(scene));
 return normalizeInitialSceneOrder([...cleaned,...DEFAULT_VIDEO_SCENES.filter(defaultScene=>!cleaned.some(s=>s.kind===defaultScene.kind)).map(scene=>({...scene,asset_id:scene.kind==="intro"?legacy.intro_asset_id||null:legacy.outro_asset_id||null,auto_play:Boolean(scene.kind==="intro"?legacy.auto_intro:legacy.auto_outro)}))]);
}
export function nextStudioScene(scenes,scene){
 if(!scene?.auto_next)return null;
 const target=scene.next_scene_id || "live";
 if(!target||target===scene.id)return null;
 return scenes.find(candidate=>candidate.id===target)||null;
}
export function sceneAutomationEnabled(flags){
 return Boolean(flags?.show_automation);
}
export function videoSceneAutomationEnabled(flags){
 return sceneAutomationEnabled(flags)&&Boolean(flags?.intro_outro_video);
}
export function remainingPreludeSeconds(start,seconds,now=Date.now()){
 return start?Math.max(0,Math.ceil((start+seconds*1000-now)/1000)):Math.max(0,seconds||0);
}
